import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Field, reduxForm, reset } from 'redux-form';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import Loader from '../../Loader';
import messages from '../../../locale/messages';
import { sendEmail } from '../../../core/email/sendEmail';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { LANDING_CONTACT_INFO_EMAIL } from '../landingContent';
// Form validation (required fields + email format)
import validate from './validate';

import s from './Contact.css';
import btn from '../shared/landingButtons.css';

class LandingContactForm extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      contactLoading: false,
    };
  }

  handleClick = async (values, dispatch) => {
    this.setState({ contactLoading: true });

    const content = {
      phoneNumber: values.phoneNumber,
      name: values.name,
      email: values.email,
      // Old: email was optional on submit
      // email: values.email || 'N/A',
      ContactMessage: values.contactMessage,
    };

    const { status } = await sendEmail(LANDING_CONTACT_INFO_EMAIL, 'contact', content);

    this.setState({ contactLoading: false });

    if (status === 200) {
      showToaster({ messageId: 'emailSent', toasterType: 'success' });
      // Only reset the form after a successful send
      dispatch(reset('LandingContactForm'));
      return;
    }

    // Old: form was reset even when the email failed
    // dispatch(reset('LandingContactForm'));
    showToaster({ messageId: 'formError', toasterType: 'error' });
  };

  // --- Field input: old version without validation UI (disabled) ---
  // renderFormControl = ({ input, label, type }) => (
  //   <div className={s.fieldWrapper}>
  //     <input
  //       {...input}
  //       type={type || 'text'}
  //       placeholder={label}
  //       className={s.contactInput}
  //     />
  //   </div>
  // );

  // --- Field input: new version with inline errors ---
  renderFormControl = ({
    input,
    label,
    type,
    meta: { touched, error },
  }) => {
    const { formatMessage } = this.props.intl;

    return (
      <div className={s.fieldWrapper}>
        <input
          {...input}
          type={type || 'text'}
          placeholder={label}
          className={cx(s.contactInput, touched && error && s.contactInputError)}
          aria-invalid={touched && error ? 'true' : 'false'}
        />
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  // --- Textarea: old version without validation UI (disabled) ---
  // renderFormControlTextArea = ({ input, label }) => (
  //   <div className={s.fieldWrapper}>
  //     <textarea
  //       {...input}
  //       placeholder={label}
  //       className={cx(s.contactInput, s.contactTextarea)}
  //     />
  //   </div>
  // );

  // --- Textarea: new version with inline errors ---
  renderFormControlTextArea = ({
    input,
    label,
    meta: { touched, error },
  }) => {
    const { formatMessage } = this.props.intl;

    return (
      <div className={s.fieldWrapper}>
        <textarea
          {...input}
          placeholder={label}
          className={cx(
            s.contactInput,
            s.contactTextarea,
            touched && error && s.contactInputError,
          )}
          aria-invalid={touched && error ? 'true' : 'false'}
        />
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    const { contactLoading } = this.state;

    return (
      <form className={s.contactForm} onSubmit={handleSubmit(this.handleClick)}>
        {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}

        <Field
          name="name"
          type="text"
          component={this.renderFormControl}
          label={formatMessage(messages.newLandingNamePlaceholder)}
        />
        <Field
          name="email"
          type="email"
          component={this.renderFormControl}
          label={formatMessage(messages.newLandingEmailPlaceholder)}
        />
        <Field
          name="phoneNumber"
          type="tel"
          component={this.renderFormControl}
          label={formatMessage(messages.newLandingPhonePlaceholder)}
        />
        <Field
          name="contactMessage"
          component={this.renderFormControlTextArea}
          label={formatMessage(messages.newLandingCommentPlaceholder)}
        />

        <Loader
          type="button"
          buttonType="submit"
          className={cx(btn.landingBtn, btn.landingBtnSubmitBlock)}
          disabled={submitting}
          show={contactLoading}
          label={formatMessage(messages.newLandingSubmitRequest)}
        />
      </form>
    );
  }
}

// Old reduxForm config (no client-side validation):
// reduxForm({
//   form: 'LandingContactForm',
// })(LandingContactForm);

LandingContactForm = reduxForm({
  form: 'LandingContactForm',
  // Validate required fields before submit
  validate,
  // Show errors after the user leaves a field
  touchOnBlur: true,
})(LandingContactForm);

export default compose(
  injectIntl,
  withStyles(s, btn),
)(LandingContactForm);
